// extracted by mini-css-extract-plugin
export default {"NavMenu":"Menu_NavMenu__rPepX","NavMore":"Menu_NavMore__ykKrt","Open":"Menu_Open__FZW-3"};